module.exports = __webpack_public_path__ + "img/Dompetkilat-Image.cc2f8c4c.png";